module.exports = __webpack_public_path__ + "static/media/375.02080bb1.webp";